import { Translations } from 'enums/Translations';
import { getStringAsPascalCase } from 'utils/getStringAsPascalCase';

export const getTranslations = (text: string) => {
  const textAsPascalFormat = getStringAsPascalCase(text);

  return Translations[textAsPascalFormat] ?? text;
};
